import React, { useEffect, useState, useContext, useCallback } from 'react'
import axios from 'axios'
import carResource from '../../helpers/CarResource'
import CarContext from '../context/CarContext'

const WPBlocks = ({view, manufacturer, modelSeries, gearboxType, fuelType, car_id, action}) => {

    const [ html, setHtml] = useState('')
    const carContext = useContext(CarContext)
    let car = false

    if( carContext && carContext.hasOwnProperty('car')) {
        car = carContext.car;
    }

    /**
     * Load single_inside blocks from template
     * because wpforms...
     */
    const loadSingleInside = () => {
        const block = document.querySelector('#block_single_inside')?.content.firstElementChild.cloneNode(true) || false
        if(block) {
            setHtml( autoFillCarFields(block).innerHTML )
        }
    }

    /**
     * Load single_after & index_after from admin_ajax
     */
    const loadAdminAjax = useCallback(() => {
        const gethtml = async () => {
            const config = {
                params: {
                   view: view,
                   action: action ?? 'vehicle_search_blocks'
                },
                headers: {
                    'Accept':'text/plain',
                    'Content-Type':'text/plain',
                    'Access-Control-Allow-Origin': '*',
                },
            }
            // only pass set parameters, no null or false
            if( manufacturer ) { config.params.manufacturer = manufacturer }
            if( modelSeries ) { config.params.modelSeries = modelSeries }
            if( fuelType ) { config.params.fuelType = fuelType }
            if( gearboxType ) { config.params.gearboxType = gearboxType }
            if( car_id ) { config.params.car_id = car_id }
    
            const url = `${process.env.REACT_APP_WP_URL}/wp/wp-admin/admin-ajax.php`
            // console.log(url)
            try {
                const results = await axios.get(url, config)
                setHtml(results.data)                
            } catch(error) {
                console.error(error)
            }
        }
        gethtml()

    },[modelSeries, manufacturer, fuelType, gearboxType, car_id, view])


    const autoFillCarFields = (node) => {
        
        if(!car) {
            return node
        }

        const classNameMapping = {
            'make':         car.manufacturer,
            'model':        car.modelSeries,
            'model-year':   car.modelYear,
            'price':        car.price,
            'reg-no':       car.registrationNumber,
            'vehicle-id':   car.waykeId,
            'anlaggning':   car.branch.name,
            'url':          window.location.href,

        }
        Object.keys(classNameMapping).forEach((key)=>{
            // Find all fields with className
            const fields = node.querySelectorAll(`.wpforms-field.${key} input`);
            // Loop all and pre-fill car data
            fields.forEach( (field) => {
                field.value = classNameMapping[key]
            })
        })

        return node
    }

    /**
     * Initiate forms for single_inside blocks
     */
    useEffect(()=>{
        /**
         * Initiate forms loaded
         */
        if(html !== '' && view === 'single_inside') {
            // if html has content, wait a moment and setup events
            setTimeout(()=>{

                const dom = new Event('DOMContentLoaded');
                const load = new Event('load');
                document.dispatchEvent(dom);
                document.dispatchEvent(load);
        
                const collapsable = document.querySelectorAll('.bb-collapse')
                collapsable.forEach( (accordion, i) => {
                    const container = accordion.querySelector('.bb-collapse-target')
                    const trigger = accordion.querySelector('.bb-collapse-trigger')
                    
                    container.addEventListener('transitionend', (e)=>{
                        // TODO: reset css height to prevent content clipping when open
                        console.dir(e);
                    })
                    accordion.addEventListener('click', (e)=>{
                        
                        if( e.target === trigger || e.target.parentElement === trigger) {
                            e.preventDefault()
                            accordion.classList.toggle('show')
                            if( container.style.maxHeight ) {
                                container.style.maxHeight = null
                            } else {
                                container.style.maxHeight = container.scrollHeight + 'px'
                            }
                        }
                    })
                    if(i === 0){
                        accordion.classList.toggle('show')
                        container.style.maxHeight = container.scrollHeight + 'px'
                    }
                })

                if(window.wpforms && window.jQuery) { 

                    // trigger init
                    window.wpforms.ready()
                    window.wpforms.load()
                    window.wpforms.bindUIActions();
                    window.wpforms.bindOptinMonster();


                }
            },1000)
        }
    },[html, view])


    useEffect(()=>{
        // make sure car is set
        if( view === 'single_inside') {
            loadSingleInside()
        } else {
            loadAdminAjax()
        }
    },[view])

    useEffect(()=>{
        // make sure car is set
        if( view !== 'single_inside') {
            loadAdminAjax()
        }
    },[manufacturer])

    return (
        <div dangerouslySetInnerHTML={{ __html: html }}></div>
    )
}

export default WPBlocks